import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class DividendAnalaysisProxy extends ProxyBase {
  GetAnalysis(data, source) {
    return this.get('GetAnalysis', data, source);
  }

  ExportData(data) {
    return this.get('DownloadAnalysis', data, null, 'download');
  }
}

const dividendAnalaysisProxy = new DividendAnalaysisProxy(
  ServiceProxyConfig.Fundamental.CashDividendAnalysis.ServiceUrl,
);
export default dividendAnalaysisProxy;
